import { baseRoutes } from '@routes/helpers/baseRoutes.ts';
import { routesPaths } from '@routes/helpers/constants.ts';
import { AppRouteConfig } from '@routes/route';

export const iamRoutes: ReadonlyArray<AppRouteConfig> = [
  {
    path: baseRoutes.iam.root,
    lazyImport: () => import('../../domains/protected/iam/IamRoute.tsx'),
    requiresAuth: true,
    resourceId: 'user',
    children: [
      {
        index: true,
        redirectTo: routesPaths.iam.users.root
      },
      {
        path: baseRoutes.iam.users.root,
        lazyImport: () => import('../../domains/protected/iam/pages/users/UsersRoute.tsx'),
        resourceId: 'user',
        redirectUnauthorizedTo: routesPaths.iam.root,
        children: [
          {
            index: true,
            lazyImport: () =>
              import('../../domains/protected/iam/pages/users/users/UsersDataGridRoute.tsx'),
            nav: {
              hideBack: true,
              breadcrumbKey: 'list'
            }
          },
          {
            path: 'new',
            lazyImport: () =>
              import('../../domains/protected/iam/pages/users/add-user/AddUsersRoute.tsx'),
            resourceId: 'user',
            nav: {
              backTo: routesPaths.iam.root,
              breadcrumbKey: 'new'
            }
          },
          {
            path: ':id',
            lazyImport: () =>
              import('../../domains/protected/iam/pages/users/user-editor/UserDetailsRoute.tsx'),
            resourceId: 'user',
            nav: {
              backTo: routesPaths.iam.root,
              breadcrumbKey: 'details'
            }
          }
        ]
      },
      {
        path: baseRoutes.iam.roles.root,
        lazyImport: () => import('../../domains/protected/iam/pages/roles/RolesRoute.tsx'),
        resourceId: 'role',
        redirectUnauthorizedTo: routesPaths.iam.root,
        children: [
          {
            index: true,
            lazyImport: () =>
              import('../../domains/protected/iam/pages/roles/roles/RolesListRoute.tsx'),
            resourceId: 'role',
            redirectUnauthorizedTo: routesPaths.iam.root,
            nav: {
              hideBack: true,
              breadcrumbKey: 'list'
            }
          },
          {
            path: 'new',
            lazyImport: () =>
              import('../../domains/protected/iam/pages/roles/role-matrix/RoleDetailsRoute.tsx'),
            resourceId: 'role',
            redirectUnauthorizedTo: routesPaths.iam.roles.root,
            nav: {
              backTo: routesPaths.iam.roles.root,
              breadcrumbKey: 'new'
            }
          },
          {
            path: ':id',
            lazyImport: () =>
              import('../../domains/protected/iam/pages/roles/role-matrix/RoleDetailsRoute.tsx'),
            resourceId: 'role',
            redirectUnauthorizedTo: routesPaths.iam.roles.root,
            nav: {
              backTo: routesPaths.iam.roles.root,
              breadcrumbKey: 'details'
            }
          }
        ]
      },
      {
        path: baseRoutes.iam.userGroups.root,
        lazyImport: () =>
          import('../../domains/protected/iam/pages/user-groups/UserGroupsRoute.tsx'),
        resourceId: 'user-group',
        redirectUnauthorizedTo: routesPaths.iam.root,
        children: [
          {
            index: true,
            lazyImport: () =>
              import('../../domains/protected/iam/pages/user-groups/user-groups/UserGroupsListRoute.tsx'),
            nav: {
              hideBack: true,
              breadcrumbKey: 'list'
            }
          },
          {
            path: 'new',
            lazyImport: () =>
              import('../../domains/protected/iam/pages/user-groups/add-user-group/AddUserGroupRoute.tsx'),
            resourceId: 'user-group',
            redirectUnauthorizedTo: routesPaths.iam.userGroups.root,
            nav: {
              backTo: routesPaths.iam.userGroups.root,
              breadcrumbKey: 'new'
            }
          },
          {
            path: ':id',
            lazyImport: () =>
              import('../../domains/protected/iam/pages/user-groups/user-group-details/UserGroupDetailsRoute.tsx'),
            resourceId: 'user-group',
            redirectUnauthorizedTo: routesPaths.iam.userGroups.root,
            nav: {
              backTo: routesPaths.iam.userGroups.root,
              breadcrumbKey: 'details'
            }
          },
          {
            path: '*',
            redirectTo: routesPaths.iam.userGroups.root
          }
        ]
      },
      {
        path: baseRoutes.iam.nodes.root,
        lazyImport: () =>
          import('../../domains/protected/iam/pages/nodes/nodes/NodesListRoute.tsx'),
        resourceId: 'node',
        redirectUnauthorizedTo: routesPaths.iam.root,
        nav: {
          hideBack: true,
          breadcrumbKey: 'list'
        }
      },
      {
        path: baseRoutes.iam.nodes.new,
        lazyImport: () =>
          import('../../domains/protected/iam/pages/nodes/node-details/NodeDetailsRoute.tsx'),
        resourceId: 'node',
        redirectUnauthorizedTo: routesPaths.iam.nodes.root,
        nav: {
          backTo: routesPaths.iam.nodes.root,
          breadcrumbKey: 'new'
        }
      },
      {
        path: baseRoutes.iam.nodes.details,
        lazyImport: () =>
          import('../../domains/protected/iam/pages/nodes/node-details/NodeDetailsRoute.tsx'),
        resourceId: 'node',
        redirectUnauthorizedTo: routesPaths.iam.nodes.root,
        nav: {
          backTo: routesPaths.iam.nodes.root,
          breadcrumbKey: 'details'
        }
      },
      {
        path: baseRoutes.iam.lists.root,
        lazyImport: () =>
          import('../../domains/protected/iam/pages/lists/lists/ListsListRoute.tsx'),
        resourceId: 'list',
        redirectUnauthorizedTo: routesPaths.iam.root,
        nav: {
          hideBack: true,
          breadcrumbKey: 'list'
        }
      },
      {
        path: baseRoutes.iam.lists.details,
        lazyImport: () =>
          import('../../domains/protected/iam/pages/lists/list-editor/ListEditorRoute.tsx'),
        resourceId: 'list',
        redirectUnauthorizedTo: routesPaths.iam.lists.root,
        nav: {
          backTo: routesPaths.iam.lists.root,
          breadcrumbKey: 'details'
        }
      },
      {
        path: baseRoutes.iam.lists.new,
        lazyImport: () =>
          import('../../domains/protected/iam/pages/lists/list-editor/ListEditorRoute.tsx'),
        resourceId: 'list',
        redirectUnauthorizedTo: routesPaths.iam.lists.root,
        nav: {
          backTo: routesPaths.iam.lists.root,
          breadcrumbKey: 'new'
        }
      },
      {
        path: '*',
        redirectTo: routesPaths.iam.root
      }
    ]
  }
];
